import React, { useState } from 'react';
import axios from 'axios';
import { AddressStep } from '../simulator/AddressStep';
import { API, validateField } from '../simulator/model';
import { errorDetails } from './model';

export const ClientAddress = ({ quote, token, onSaved, onCancel, track }) => {
  const [data, setData] = useState(quote);
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const save = async () => {
    const error = validateField('address', data);
    if (error) { setErrors({ address: error }); return; }
    setBusy(true);
    try {
      await axios.patch(`${API}/api/client/quote/address`, { devis_id: quote.id, address: data.address, address_details: data.address_details }, { headers: { Authorization: `Bearer ${token}` } });
      onSaved(data.address);
    } catch (err) { setErrors({ address: errorDetails(err).message }); }
    finally { setBusy(false); }
  };
  return <section className="booking-client-card" data-testid="client-address-form"><h1>Où se trouve le bien ?</h1>
    <AddressStep data={data} update={(patch) => setData((previous) => ({ ...previous, ...patch }))} errors={errors} onBlur={(name) => setErrors({ [name]: validateField(name, data) })} track={track} hideMetrics />
    <div className="sim-actions"><button type="button" className="sim-secondary" data-testid="client-address-cancel" disabled={busy} onClick={onCancel}>Retour</button><button type="button" className="sim-primary" data-testid="client-address-save" disabled={busy} onClick={save}>Enregistrer mon adresse</button></div>
  </section>;
};